import {styled} from '@linaria/react';
import React, {FC} from 'react';
import {COLORS} from '../../../constants/colors';
import {Icon} from '../Icon/Icon';
import {GenericIconName} from '../Icon/IconName';

export const ButtonLoadingIcon: FC<{
  variant?: 'light' | 'dark';
}> = ({variant}) => {
  return (
    <LoadingSpinner
      asset={GenericIconName.Spinner}
      size="S"
      data-invert={variant === 'light'}
    />
  );
};

const LoadingSpinner = styled(Icon)`
  position: absolute;
  inset: 0;
  justify-self: center;
  margin: auto;
  animation: spin 900ms linear infinite;
  color: ${COLORS['Fill.Black']};

  &&&[data-invert='true'] {
    color: ${COLORS['Fill.White']};
  }

  @keyframes spin {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(360deg);
    }
  }
`;
